import { render, staticRenderFns } from "./integrations-tabs.vue?vue&type=template&id=eed12cea&"
import script from "./integrations-tabs.vue?vue&type=script&lang=js&"
export * from "./integrations-tabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports